module.exports = __webpack_public_path__ + "img/29.25c4846c.jpg";